export function getEnvironmentVariable(variable) {
  const lulaVars = window['_lula_environment_variables'];
  if (lulaVars) {
    return lulaVars[variable];
  }
  return process.env[variable];
}
